<!-- display-mobile-04 preview — a display ad at the head of a publisher page -->
<app-mobile-frame>
  <!-- START: Publisher page -->
  <div class="da-page">
    <!-- START: Real ad -->
    <!-- This placement opens the page, so there is no browser bar and no
         article text above it — the ad is the first thing on the screen. -->
    <div class="da-ad">
      <i class="bi bi-info-circle da-adchoices"></i>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </a>

      <div class="da-ad-row d-flex flex-row">
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-creative">
          <img *ngIf="creativeImage" class="da-creative-image" [src]="creativeImage" alt="" />
          <div *ngIf="!creativeImage" class="da-creative-image creative-missing" [title]="missingDimensionLabel">{{ missingDimensionShortLabel }}</div>
        </a>

        <div class="da-copy">
          <div class="da-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>

          <div class="da-footer d-flex flex-row align-items-center">
            <span class="da-badge">Ad</span>
            <span class="da-advertiser">Valamar</span>
            <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-cta ms-auto">
              {{ data.ctaText || "Your call to action" }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Real ad -->

    <!-- The article the ad sits above, running to the bottom of the screen -->
    <div class="da-bars d-flex flex-column">
      <span
        *ngFor="let bar of bodyBars; let last = last"
        class="da-bar placeholder"
        [class.da-bar-short]="last"
      ></span>
    </div>
  </div>
  <!-- END: Publisher page -->
</app-mobile-frame>
